import { Component, OnInit } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { licenceModelsForm } from '../../forms/myTitle'
import { AuthService } from '../../api/services/auth.service'
import { Router } from '@angular/router'
import { validateAllFormFields } from '../../formUtils'

@Component({
  selector: 'app-register',

  templateUrl: './register.component.html',
})
export class RegisterComponent implements OnInit {
  form: FormGroup
  length
  value

  displaypopup: boolean = false

  constructor(
    private router: Router,
    private authService: AuthService,
  ) {
    this.form = licenceModelsForm
  }

  ngOnInit() {
    this.displaypopup = true
  }

  onSubmitForm() {
    if (this.form.invalid) {
      validateAllFormFields(this.form)
    }
    const body = { ...this.form.value, canContinue: false }
    this.authService
      .authRegister({
        body: body,
      })
      .subscribe((res) => {
        if (res.status == 'Success') this.router.navigate(['login'])
        else alert(res.statusMessage)
      })
  }

  onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData
    let pastedText = clipboardData.getData('text').trim()
    const keyParts = pastedText.split('-')

    setTimeout(() => {
      this.form.get('keyOne').setValue(keyParts?.[0])
      this.form.get('keyTwo').setValue(keyParts?.[1])
      this.form.get('keyThree').setValue(keyParts?.[2])
      this.form.get('keyFour').setValue(keyParts?.[3])
      this.form.get('keyFive').setValue(keyParts?.[4])
    }, 0)
  }
}
